import { ConnectionState } from '../../_hooks/use-service-oauth-connection'
import { SERVICE_TYPES } from '../../_utils/constants'
import { ApiKeyField } from './api-key-field'
import { NameField } from './name-field'
import { OAuthConnectionField } from './oauth-connection-field'
import { ServiceTypeField } from './service-type-field'
import { UrlField } from './url-field'

type ServiceRegistryFormFieldsProps = {
  oauthInit: () => void
  serviceType?: string
  disabled: boolean
  canOAuthInit: () => boolean
  oauthConnectionStatus: ConnectionState['status']
  isOAuthConnecting?: boolean
  bypassVerifyAnimation: boolean
}

export function ServiceRegistryFormFields({
  oauthInit,
  serviceType,
  disabled,
  oauthConnectionStatus,
  canOAuthInit,
  isOAuthConnecting,
  bypassVerifyAnimation,
}: ServiceRegistryFormFieldsProps) {
  const isServiceTypeApiKey = serviceType === SERVICE_TYPES.MCP_KEY
  const isServiceTypeOAUth = serviceType === SERVICE_TYPES.MCP_OAUTH2

  return (
    <div className='space-y-4'>
      <NameField disabled={disabled} />
      <UrlField disabled={disabled} />
      <ServiceTypeField disabled={disabled} />
      {isServiceTypeApiKey && <ApiKeyField disabled={disabled} />}
      {isServiceTypeOAUth && (
        <OAuthConnectionField
          onClick={oauthInit}
          disabled={disabled || !canOAuthInit()}
          loading={isOAuthConnecting}
          bypassVerifyAnimation={bypassVerifyAnimation}
          error={oauthConnectionStatus === 'error'}
        />
      )}
    </div>
  )
}
